module.exports = __webpack_public_path__ + "img/18-02_Being Comfortable With Uncertainty.23db254c.svg";